// extracted by mini-css-extract-plugin
module.exports = {"ct-legend":"ClientMinimum_ct-legend_1qcmI","inactive":"ClientMinimum_inactive_3DWJ0","ct-legend-inside":"ClientMinimum_ct-legend-inside_C4mnz"};